import React from "react";
import { Link } from "react-router-dom";
import { Card } from "@/CommonElements/Hajj/Card";
import { useTranslation } from "react-i18next";
import { STACK_4 } from "./PilgrimDetails";
import { LabelValue } from "@Component/Value";
import { Tag } from "antd";
import { useLocalizedText } from "@/utils/hooks/useLocalizedText";
import { useSystem } from "@/utils/hooks/useLocation";

const formatReportDate = (reportedAt) => {
  if (!reportedAt) return "-";
  const s = String(reportedAt).slice(0, 10);
  if (s.length < 10) return s;
  const [y, m, d] = s.split("-");
  return `${d}-${m}-${y}`;
};

export const DetailedData = (props) => {
  const { t } = useTranslation();
  const { getLocalizedText } = useLocalizedText();
  const { currentSystem } = useSystem();
  const { isLoading } = props;

  // Mock data - replace with actual props/data

  const {
    visa_number,
    visa_source,
    organizer_name,
    campaign_number,
    bag_number_madinah,
    pilgrim_status,
    incident_reports,
    campaign_name,
    nusk_group_number,
    nusk_group_name,
  } = props;

  const VerticalLabelValue = ({ value, ...props }) => (
    <LabelValue loading={isLoading} value={value || "-"} direction="vertical" {...props} />
  );

  return (
    <Card header={<span className="H5">{t("DETAILED_DATA")}</span>}>
      <STACK_4>
        <VerticalLabelValue
          label={t("VISA_NUMBER")}
          value={visa_number}
        />
        <VerticalLabelValue
          label={t("VISA_SOURCE")}
          value={visa_source}
        />
        <VerticalLabelValue
          label={t("MAKKAH_GROUPS_COL_ORGANIZER_NAME")}
          value={organizer_name}
        />
        {!!campaign_name && (
          <VerticalLabelValue
            copyValue={campaign_name}
            label={t("CAMPAIGN_NAME")}
            value={campaign_name}
          />
        )}
        {!!campaign_number && (
          <VerticalLabelValue
            copyValue={campaign_number}
            label={t("CAMPAIGN_NUMBER")}
            value={campaign_number}
          />
        )}
        {!!nusk_group_number && (
          <VerticalLabelValue
            copyValue={nusk_group_number}
            label={t("NUSUK_GROUP_NUMBER")}
            value={nusk_group_number}
          />
        )}
        {!!nusk_group_name && (
          <VerticalLabelValue
            label={t("NUSUK_GROUP_NAME")}
            value={nusk_group_name}
          />
        )}
        <VerticalLabelValue
          copyValue={bag_number_madinah}
          label={t("BAG_NUMBER_MADINAH")}
          value={bag_number_madinah}
        />
        <VerticalLabelValue
          label={t("PILGRIM_STATUS")}
          value={pilgrim_status}
          renderValue={(value) => (
            <Tag color={value.color || "red"}>
              {getLocalizedText(pilgrim_status?.label_ar, pilgrim_status?.label_en) ?? "-"}
            </Tag>)
          }
        />
        <VerticalLabelValue
          label={t("REPORTS")}
          value={incident_reports}
          renderValue={(value) => {
            const reports = Array.isArray(value) ? value : [];
            if (reports.length === 0) return "-";
            return (
              <ul className="list-unstyled mb-0 small p-0">
                {reports.map((report, index) => {
                  const caseTypeName = report?.case_type
                    ? getLocalizedText(report.case_type.name_ar, report.case_type.name_en)
                    : "-";
                  const date = formatReportDate(report?.reported_at);
                  return (
                    <li
                      key={report?.incident_number ?? index}
                      className="d-flex align-items-center flex-wrap gap-2 py-1 border-bottom border-light border-opacity-50"
                      style={index === reports.length - 1 ? { borderBottom: "none" } : undefined}
                    >
                      <span className="text-muted">{date}</span>
                     {report?.incident_number && <Tag className="mb-0" style={{ fontSize: "inherit" }}>
                        <Link
                          to={`/app/${currentSystem}/reports/${report?.incident_number}/view`}
                          className="text-decoration-none text-inherit"
                        >
                          {report?.incident_number}
                        </Link>
                      </Tag>}
                      <span className="text-dark">{caseTypeName}</span>
                    </li>
                  );
                })}
              </ul>
            );
          }}
        />
      </STACK_4>
    </Card>
  );
};
